import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";

const RequireAdmin: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { isAuthed, loading } = useAdminAuth();
  const location = useLocation();
  if (loading) return <div className="p-6 text-gray-500">Yükleniyor...</div>;
  if (!isAuthed) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return <>{children}</>;
};

export default RequireAdmin;
